import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '~/lib/utils'

const tagVariants = cva(
  'tag tracking-normal font-mono py-2xs px-2xs-plus gap-2xs max-w-[350px] rounded-full transition-colors inline-flex items-center unstyled-link',
  {
    variants: {
      backgroundColour: {
        none: '[a]:hover:!underline !p-0',
        'ink-blue': 'bg-blue-d text-white [a]:hover:bg-blue-d-60 ',
        'light-blue': 'bg-blue-l text-blue-d [a]:hover:bg-blue-l-60',
        'light-pink': 'bg-pink text-blue-d [a]:hover:bg-pink-60',
        'light-aqua': 'bg-green text-blue-d [a]:hover:bg-green-60',
        'light-purple': 'bg-purple text-blue-d [a]:hover:bg-purple-60',
        'light-orange': 'bg-orange text-blue-d [a]:hover:bg-orange-60'
      }
    },
    defaultVariants: {
      backgroundColour: 'none'
    }
  }
)

export type TagProps = {
  data: {
    label?: string
    taxonomy?: { entryTitle: string }
    backgroundColour?: VariantProps<typeof tagVariants>['backgroundColour']
    icon?: Image
    link?: string
    showIcon?: boolean
  }
  className?: string
  layoutColour?: AllBackgroundColours
}

function Tag({ data, className, layoutColour }: TagProps) {
  const {
    label,
    taxonomy,
    backgroundColour,
    icon,
    link,
    showIcon = true
  } = data

  const iconImage =
    ['ink-blue', 'mid-blue'].includes(backgroundColour ?? '') ||
    ((backgroundColour === 'none' || backgroundColour === null) &&
      ['ink-blue', 'mid-blue'].includes(layoutColour ?? ''))
      ? icon?.asset.sys.uri.replace('ink-blue', 'white')
      : icon?.asset.sys.uri

  const previewUrl =
    'https://preview-websitemodern-uni-hull.cloud.contensis.com'

  if (link)
    return (
      <a
        href={link}
        className={cn(
          tagVariants({ backgroundColour: backgroundColour || 'none' }),
          ['ink-blue', 'mid-blue'].includes(layoutColour ?? '') &&
            (backgroundColour !== 'none' || backgroundColour !== null)
            ? 'hover:text-white'
            : '',
          className
        )}
      >
        {showIcon && icon?.asset.sys.uri && (
          <img
            className='h-xs w-xs'
            src={`${previewUrl}${iconImage}`}
            alt=''
            role='presentation'
          />
        )}
        <span>{label || taxonomy?.entryTitle}</span>
      </a>
    )
  return (
    <div className={cn(tagVariants({ backgroundColour }), className)}>
      {showIcon && icon?.asset.sys.uri && (
        <img
          className='h-xs w-xs'
          src={`${previewUrl}${iconImage}`}
          alt=''
          role='presentation'
        />
      )}
      <span>{label || taxonomy?.entryTitle}</span>
    </div>
  )
}

export default Tag
